export default __webpack_public_path__ + "../staticImages/sommergruesse_spanien-260.png";